import React from 'react'
import { ModalType } from '@enums/ModalType'
import styles from './bankListShimmer.module.scss'

interface BankListShimmerProps {
  shimmerNumber?: number
  shimmerSize?: ModalType
}

const BankListShimmer = ({ shimmerNumber = 20, shimmerSize = ModalType.MEDIUM }: BankListShimmerProps) => {
  const dummyBanks = Array.from({ length: shimmerNumber })

  return (
    <div className={styles.bankShimmer}>
      {dummyBanks.map((_, index) => (
        <div key={index} className={`${styles.bankDiv} ${styles[shimmerSize]}`}>
          {/* Empty div, just for shimmer effect */}
        </div>
      ))}
    </div>
  )
}

export default BankListShimmer
